import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadProviderListBegin, loadProviderListFailed, loadProviderListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';
import { loadGeographyListSuccessful } from '../../Geography/actions';

export default function* loadProviderList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
    } = payload;
    let pool = {
      limit,
      page,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }
    const url = `${BACKEND_URL}/providers`;
    yield put(loadProviderListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield getBodyJson(dataResponse);
    if (dataResponse.status === OK && data?.data) {
      yield put(loadProviderListSuccessful(data));
      yield call(resolveActionPromise(action, data?.data || []));
    } else {
      yield put(loadProviderListFailed());
      yield call(rejectActionPromise(action, data.data));
    }
  } catch (e) {
    yield put(loadProviderListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
